// extracted by mini-css-extract-plugin
export default {"createAnotherCheckbox":"createAnotherCheckbox---gw63k"};